<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12">
        <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "timer" [fullScreen] = "false"><p style="color: white" >
            Loading... </p></ngx-spinner>
        <!-- แบบบันทึกทั้งหมดนั่นล่ะ -->
        <div class="card">
            <div class="card-header bg-primary">แบบฟอร์มขอเบิกปัจจัย</div>
            <div class="card-body">
                <div class="row">
                <!-- รายการชาวไร่  -->

                    <div class="col-5">
                        <div class="card">
                            <div class="card-body">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon1">เบิกปัจจัย 65/66</span>
                                    <input type="text" class="form-control" placeholder="ป้อนรหัสโควต้า" list="farmer" id="codefm">
                                    <datalist  id="farmer">
                                        <option  *ngFor="let item of famerlist">

                                           [{{item.fmcode_b1}}] {{item.fmname}} จำนวนแปลง {{item.cnt}}
                                           <lable *ngIf="item.approve==='Y'">เบิกได้</lable>
                                            <lable *ngIf="item.PromiseIN == 0">สัญญายังไม่ผ่าน</lable>
                                            <lable *ngIf="item.zoneban ==='Y' ">อยู่โซนต้องห้าม</lable>

                                        </option>
                                    </datalist>
                                    <button class="btn btn-outline-dark" (click)="goloaddata();"><i class="fas fa-search"></i></button>
                                </div>
                                <p style="color: red;">ตัวอย่าง [0123456789] </p>

                                <table class="table">
                                    <thead>
                                        <tr>
                                            <td>เลขแปลง</td>
                                            <td>โซน</td>
                                            <td>รูท</td>
                                            <td>ประเภท</td>
                                            <td>พื้นที่</td>
                                            <td>เบิกได้</td>
                                            <td>เบิกแล้ว</td>
                                            <td>เลือก</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of dataonefarmer">
                                            <td>{{item.intlandno}}</td>
                                            <td>{{item.supzone}}</td>
                                            <td>{{item.route}}</td>
                                            <td>{{item.canetype}}</td>
                                            <td>{{item.landvalue}}</td>

                                            <td>{{item.caneGetfert12}}</td>
                                            <td>{{item.Getferted}}</td>
                                            <td><button class="btn btn-success" (click)="Selectoneplant(item.itid);"><i class="fas fa-check-circle"></i></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                  <!-- รายการชาวไร่  -->

                     <!-- ฟอร์มบันทึกกรอกปัจจัย -->
                <div class="col-7" [hidden]="ckfarmercan">
                    <div class="card">
                        <div class="card-header bg-warning" *ngIf="oneplant != null"> ฟอร์มขอเบิกปัจจัยการผลิตปี 65/66 [{{famername}}]</div>
                        <div class="card-body">
                          <form [formGroup]="Formfactor">
                            <table class="table">
                                <tbody >
                                    <tr>
                                        <td>แปลง</td>
                                        <td *ngIf="oneplant != null" colspan="3"><input type="text" class="form-control" [value]="intlandno" disabled></td>
                                    </tr>

                                    <tr>
                                        <td>สต๊อค </td>
                                        <td colspan="3">
                                            <select class="form-control" formControlName="localstock"
                                            [ngClass]="{ 'is-invalid': submitted && factor.localstock.errors }"
                                            >
                                                <option [value]="0" disabled selected>กรุณาเลือก</option>
                                                <option *ngFor="let item of fertilizerstock" [ngValue]="item.StockID">{{item.Stockname}}</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <div *ngIf="submitted && factor.localstock.errors" class="invalid-feedback">
                                        <div *ngIf="factor.localstock.errors?.required">กรุณาเลือก Stock </div>
                                    </div>

                                    <tr>
                                        <td>ปุ๋ยเคมี</td>
                                        <td>
                                            <select class="form-select" formControlName="cemecal"
                                            [ngClass]="{ 'is-invalid': submitted && factor.cemecal.errors }"
                                            (change)="ChangeValue(1)"
                                            >
                                                <option [ngValue]="[0,0]" selected>++++ ไม่เลือกสูตรปุ๋ยเคมี ++++</option>
                                                <option *ngFor="let item of chemicaldata" [ngValue]="[item.stock_id,item.per_unit]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text" >จำนวน</span>
                                                <input type="number" min="0" class="form-control" formControlName="countcemecal"
                                                [ngClass]="{ 'is-invalid': submitted && factor.countcemecal.errors }">
                                                <span class="input-group-text" *ngFor="let list of oneplant" value="0">
                                                    เบิกไปแล้ว <span class="badge bg-primary">{{list.Getferted}}</span>
                                                    เบิกได้อีก <span class="badge badge bg-success">{{list.caneGetfert12}}</span>
                                                </span>
                                              </div>
                                        </td>
                                    </tr>

                                    <div *ngIf="submitted && factor.cemecal.errors" class="invalid-feedback">
                                        <div *ngIf="factor.cemecal.errors.required">กรุณาเลือก สูตรปุ๋ย </div>
                                    </div>
                                    <div *ngIf="submitted && factor.countcemecal.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countcemecal.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>

                                    <tr>
                                        <td>ปุ๋ยอินทรีย์</td>
                                        <td>
                                            <select class="form-select" formControlName="fertilizer"  (change)="ChangeValue(2)"
                                            [ngClass]="{ 'is-invalid': submitted && factor.fertilizer.errors }">
                                                <option [ngValue]="['','0']" selected>++++ ไม่เลือกปุ๋ยอินทรีย์ ++++</option>
                                                <option *ngFor="let item of organicdata" [ngValue]="[item.stock_id,item.per_unit]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text" >จำนวน</span>
                                                <input type="number" min="0" class="form-control" formControlName="countfertilizer"
                                                [ngClass]="{ 'is-invalid': submitted && factor.countfertilizer.errors }" value="0">
                                                <span class="input-group-text" *ngFor="let list of oneplant">
                                                    เบิกไปแล้ว <span class="badge bg-primary">{{list.GetOrganic}}</span>
                                                    เบิกได้อีก <span class="badge badge bg-success">{{cangetcaneOrganic}}</span>
                                                </span>
                                              </div>
                                        </td>
                                    </tr>

                                    <div *ngIf="submitted && factor.fertilizer.errors" class="invalid-feedback">
                                        <div *ngIf="factor.fertilizer.errors.required">กรุณาเลือกปุ๋ยอินทรีย์ </div>
                                      </div>
                                    <div *ngIf="submitted && factor.countfertilizer.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countfertilizer.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>

                                    <tr>
                                        <td>โดโลไมท์</td>
                                        <td>
                                            <select class="form-select" formControlName="dolomite"
                                            [ngClass]="{ 'is-invalid': submitted && factor.dolomite.errors }"
                                            >
                                                <option [ngValue]="['','0']" selected>++++ ไม่เลือกรายการโดโลไมท์ ++++</option>
                                                <option *ngFor="let item of dolomitedata" [ngValue]="[item.stock_id,item.per_unit]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text" >จำนวน</span>
                                                <input type="number" min="0" class="form-control" formControlName="countdolomite"
                                                [ngClass]="{ 'is-invalid': submitted && factor.countdolomite.errors }">
                                                <span class="input-group-text" *ngFor="let list of oneplant " value="0">
                                                    เบิกไปแล้ว <span class="badge bg-primary">{{list.GetDolomite}}</span>
                                                    <!--เบิกได้อีก <span class="badge badge bg-success">{{list.caneDolomites}}</span>-->
                                                </span>
                                              </div>
                                        </td>
                                    </tr>

                                    <div *ngIf="submitted && factor.dolomite.errors" class="invalid-feedback">
                                        <div *ngIf="factor.dolomite.errors.required">กรุณาเลือกโดโลไมท์ </div>
                                      </div>
                                    <div *ngIf="submitted && factor.countdolomite.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countdolomite.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>

                                    <tr>
                                        <td>ยา</td>
                                        <td>
                                            <!-- <select class="form-select" formControlName="medical"
                                            [ngClass]="{ 'is-invalid': submitted && factor.medical.errors }">
                                                <option [ngValue]="['0','0']" selected>++++ ไม่เลือกรายการยา ++++</option>
                                                <option *ngFor="let item of medicdata" [ngValue]="[item.stock_id,item.per_unit]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select> -->
                                            <input type="text" class="form-select" formControlName="medical" list="allmedical"
                                            [ngClass]="{ 'is-invalid': submitted && factor.medical.errors }">
                                            <datalist id="allmedical">
                                                <option [ngValue]="['','0']" selected>[0000-0000] ไม่เลือกรายการยา </option>
                                                <option *ngFor="let item of medicdata" [ngValue]="[item.stock_id,item.per_unit]">[{{item.stock_id}}] | {{item.description}}</option>
                                            </datalist>
                                        </td>
                                        <td>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text" >จำนวน</span>
                                                <input type="number" min="0" class="form-control" formControlName="countmedical"
                                                [ngClass]="{ 'is-invalid': submitted && factor.countmedical.errors }" value="0">
                                                <span class="input-group-text" >เบิกไปแล้ว  เบิกได้อีก</span>
                                              </div>
                                        </td>
                                    </tr>
                                    <div *ngIf="submitted && factor.medical.errors" class="invalid-feedback">
                                        <div *ngIf="factor.medical.errors.required">กรุณารายการยา </div>
                                      </div>
                                    <div *ngIf="submitted && factor.countmedical.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countmedical.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>

                                    <tr>
                                        <td>อุปกรณ์</td>
                                        <td>
                                            <input type="text" class="form-select" placeholder="++ เลือกรายการอุปกรณ์ ++" formControlName="machine"  list="machinelist" [ngClass]="{ 'is-invalid': submitted && factor.machine.errors }">
                                            <!-- <select id="machinelist" class="form-select" placeholder="++ เลือกรายการอุปกรณ์ ++" formControlName="machine"  list="machinelist" [ngClass]="{ 'is-invalid': submitted && factor.machine.errors }">
                                                <option [ngValue]="00" selected>++ ไม่เลือกรายการอุปกรณ์ ++</option>
                                                <option *ngFor="let item of machinedata" [ngValue]="item.stock_id">[{{item.stock_id}}] | {{item.description}}</option>
                                            </select> -->
                                            <datalist id="machinelist">
                                                <option [ngValue]="['','0']" selected>[0000-0000] ไม่เลือกรายการอุปกรณ์ </option>
                                                <option *ngFor="let item of machinedata" [ngValue]="item.stock_id">[{{item.stock_id}}] | {{item.description}}</option>
                                            </datalist>
                                        </td>
                                        <td>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text" >จำนวน</span>
                                                <input type="number" min="0" class="form-control" formControlName="countmachine"
                                                [ngClass]="{ 'is-invalid': submitted && factor.countmachine.errors }" value="0">
                                                <span class="input-group-text" >เบิกไปแล้ว  เบิกได้อีก</span>
                                              </div>
                                        </td>
                                    </tr>
                                    <div *ngIf="submitted && factor.machine.errors" class="invalid-feedback">
                                        <div *ngIf="factor.machine.errors.required">กรุณาเลือกอุปกรณ์ </div>
                                      </div>
                                    <div *ngIf="submitted && factor.countmachine.errors" class="invalid-feedback">
                                        <div *ngIf="factor.countmachine.errors.required">กรุณาระบุจำนวน ถ้าไม่มีให้ใส่ 0 </div>
                                    </div>

                                    <tr>
                                        <td></td>
                                        <td>
                                            <div class="input-group mb-3">
                                                <input class="form-check-input mt-0" type="checkbox" value="1" formControlName="cash">  &nbsp; &nbsp; เงินสด
                                            </div>
                                        </td>
                                        <td colspan="2" style="color: red;"> หากไม่ได้เบิกส่วนอื่น ๆ ให้เลือก ไม่เลือกรายการ  ให้กรอกจำนวน 0 </td>
                                    </tr>
                                </tbody>
                            </table> <hr>
                        </form>
                            <button class="btn btn-info" (click)="Savedatafactor();">บันทึก</button>
                            <button class="btn btn-default float-right" (click)="cleardata();">กรอกใหม่</button>
                        </div>
                    </div>
                </div>
                <!-- ฟอร์มบันทึกกรอกปัจจัย -->
                </div>


            </div>
        </div>
        <!-- แบบบันทึกทั้งหมดนั่นล่ะ -->

        <!--  รายการแสดงเบิกปัจจัย -->
        <div class="card">
            <div class="card-header">
                <i class="fas fa-table"></i> ข้อมูลการเบิกปัจจัย ปี 65/66
            </div>
            <div class="card-body">
                <table class="table">
                    <thead>
                        <tr>
                            <td>เลขที่</td>
                            <td>วันที่</td>
                            <td>ชื่อ</td>
                            <td>แปลง</td>
                            <td>รายการ</td>
                            <td>สต็อค	</td>
                            <td>พิมพ์</td>
                            <td>ยกเลิก</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of onecode">
                            <td>{{data.docid}}</td>
                            <td>{{data.datepost_th}}</td>
                            <td>{{data.fmname}}</td>
                            <td>{{data.intlandno}}</td>
                            <td>{{data.desc1}} | {{data.amt1}} {{data.desc2}} | {{data.amt2}} {{data.desc3}} | {{data.amt3}}
                                {{data.desc4}} | {{data.amt4}} {{data.desc5}} | {{data.amt5}}</td>
                            <td>{{data.Stockname}}</td>
                            <td>
                                <button class="btn btn-sm">
                                <a  [routerLink]="['/docfertilizer/6566/'+data.fmcode+'/'+data.docid+'/0']" routerLinkActive="active" target="_blank" ><i class="fas fa-print"></i></a>

                                </button>
                            </td>
                            <td><button class="btn btn-danger" (click)="cancledata(data.docid)"><i class="far fa-window-close"></i></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
         <!--  รายการแสดงเบิกปัจจัย -->
    </div>
</div>
<app-footer></app-footer>
